import ApplicationController from "./application_controller.js"

export default class extends ApplicationController {

  submit(event) {
    event.preventDefault()
    console.log(event)

    const url = event.target.action
    const data = new URLSearchParams(new FormData(event.target))

    fetch(url, {
      method: "POST",
      body: data
    }).then(response => {
      window.location.reload()
    })
  }
}
